import React, { useState, useMemo } from 'react';
import { v4 as guid } from 'uuid';
import { ChipCheckbox } from '../../../../../base/components/Forms/ChipCheckbox';
import { Icon } from '../../../../../base/components/Icon';
import { Modal } from '../../../../../base/components/Modal';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { vacancyFormActions } from '../../redux/slices/vacancyFormSlice';

export const LanguageSelectChip = () => {
    const dispatch = useAppDispatch();
    const {
        vacancyForm: {
            fields: { requiredLanguageId },
        },
        employerApp: {
            config: { language },
        },
    } = useAppSelector((state) => state);

    const [isLanguageModalVisible, setIsLanguageModalVisible] = useState(false);

    const languageClickHandler = () => {
        if (requiredLanguageId !== null) {
            dispatch(vacancyFormActions.setField({ id: 'requiredLanguageId', value: null }));
            return;
        }
        setIsLanguageModalVisible(true);
    };

    const languageSelectHandler = (value: number) => {
        dispatch(vacancyFormActions.setField({ id: 'requiredLanguageId', value }));
        setIsLanguageModalVisible(false);
    };

    const languageName = useMemo(() => {
        const name = language.find((i) => i.id === requiredLanguageId)?.name;
        return name ? `: ${name}` : '';
    }, [language, requiredLanguageId]);

    return (
        <>
            <ChipCheckbox
                icon='language-light'
                text={`${__t('Знание языка')}${languageName}`}
                id='requiredLanguageId'
                checked={requiredLanguageId !== null}
                onChange={() => void 0}
                onClick={languageClickHandler}
            />
            <Modal
                className='language-modal-content'
                visible={isLanguageModalVisible}
                visibilityHandler={() => setIsLanguageModalVisible(false)}
            >
                <>
                    <h4 className='language-modal-content__title'>
                        {__t('Знание какого языка требуется к вашей вакансии?')}
                    </h4>
                    <ul className='language-modal-content__list'>
                        {language.map((l) => (
                            <li
                                key={guid()}
                                className='language-modal-content__list-item'
                                onClick={() => languageSelectHandler(l.id)}
                            >
                                <>
                                    {l.name}
                                    {l.id === requiredLanguageId ? <Icon icon='check' size='24' /> : null}
                                </>
                            </li>
                        ))}
                    </ul>
                </>
            </Modal>
        </>
    );
};
